import React,{Component} from 'react';
import { login } from "../../services/GameServices";
import logo from "../../assets/img/thetagocld.png";
import styled from 'styled-components';

const SButton = styled.button`
background: ${props => props.primary ? " #c8aa58" : "#002FAA"} ;
color: white;
font-size: 16px;
margin: 1em;
padding: 0.25em 1em;
width: 100px;
border: ${props => props.primary ? "2px solid #c8aa58" : " 2px solid #002FAA"} ; 
/* border-radius: 3px; */
`;
const Input = styled.input`
  padding: 0.5em;
  margin: 0.5em;
  margin-top:15px;
  min-width:250px;
  border: 2px solid #002FAA;
  text-align:center;
`;

class Signin extends Component {
    constructor(props){
        super(props);
        this.state={
            name:'',
            pass:''
        }
    }
    componentDidMount(){
        let g = localStorage.getItem("NAME") || "x";
        console.log("Current saved name",g);
        if(g !=="x" && g!=="not found"){
            console.log("User is INside")
            let hist= this.props.history;
            hist.push({
                pathname:`/`,
                query:  {log:true}
              });
        }
    }
    handleNameChange= (e)=> {
        this.setState({ name: e.target.value });
      }
    handlePassChange= (e)=> {
    this.setState({ pass: e.target.value });
    }
    error = () => {
        console.log('Email and password combination is incorrect');
        alert('Email and password combination is incorrect');
    }
    authenticate = () => {
        
        console.log("Checkinsfg");
        let hist= this.props.history;
        login({
            email: this.state.name,
            password: this.state.pass
          }).then(function(resp, err) {
            if (err) {
              console.log("an error");
              console.log(err);
              this.error();
              //call error message 
            } 
            else if (resp) {
              if (resp.data.err) {
                console.log("response error", resp.data.err);
                this.error();
              } 
              else {
                console.log("response is cool ", resp.data.data);
                //print response and get token and save it
                //token is in resp.data.data
                let token = resp.data.data;
                console.log("Returned ",token);
                //must set either token or password
                localStorage.setItem("NAME", token);
                hist.push({
                    pathname:`/`,
                    query:  {log:true}
                  });
                
              }
              console.log(resp);
            } 
            else {
              console.log("No response what so ever");
              this.error();
            }
          }).catch(err =>{
            console.log("trouble loggin in " ,err);
            this.error();
        })
        
      }
    render(){
        return(
            <div style={{textAlign:"center"}}> 
              <div className="logo" style={{padding:50}}>
                <img style ={{width:300}}src={logo} alt="logo_image" />
              </div>
                <h4 style={{color:'#002FAA'}}> Please login to continue
                </h4>
                <div style={{ padding: 20,paddingTop:0 }}>
                    {/* <h3>USERNAME</h3> */}
                    <Input type="email" placeholder="Enter User Name"
                        onChange={this.handleNameChange}  />
                    {/* <h3>PASSWORD</h3> */}
                    <br />
                    <Input type="password" placeholder="Enter Password"
                        onChange={this.handlePassChange}  />
                    <br />
                    <SButton  onClick={this.authenticate}>Sign in</SButton>
                </div>

            </div>
        )
    }
}
export default Signin;


// WEBPACK FOOTER //
// ./src/views/Quiz/Signin.jsx